import clsx from 'clsx';
import { Icon } from '@seeqdev/qomponents';
import type { Sort } from '@/trendData/trendData.constants';

interface SortIconProps extends Partial<Omit<Sort, 'sortBy'>> {
  sortProperty: string;
  /** property currently sorted on; absent when no sort is applied */
  sortBy?: string;
}

/** Icon to indicate sorting, e.g. table column headers */
export const SortIcon = ({ sortProperty, sortBy, sortAsc }: SortIconProps) => {
  const isActiveSort = sortBy === sortProperty;
  const activeSortAsc = sortAsc ?? true;

  return (
    <Icon
      testId={`sortProperty_${sortProperty}`}
      icon={clsx({
        'fa-sort-asc': isActiveSort && activeSortAsc,
        'fa-sort-desc': isActiveSort && !activeSortAsc,
        'fa-sort': !isActiveSort,
      })}
      type={isActiveSort ? 'info' : 'dark-gray'}
      extraClassNames="ml5 cursorPointer"
    />
  );
};
